import { Takeover } from 'ui/workflows/takeover';
import { PageContainer } from 'modules/experiments/components/pages/CommonStyled';
import { ChooseCampaignTakeoverProps } from 'modules/experiments/types';
import { useChooseCampaignTakeover, useExperimentsTranslations } from 'modules/experiments/hooks';
import { ErrorBoundary } from 'modules/error';
import { Product, Team } from 'teams';
import { TakeoverMainHeader } from './TakeoverMainHeader';
import { ChooseCampaignBody } from './ChooseCampaignBody';

export const ChooseCampaignDrawer = ({ onClose }: ChooseCampaignTakeoverProps) => {
  const { closeChooseCampaignTakeover } = useChooseCampaignTakeover();
  const { t } = useExperimentsTranslations();
  const handleOnClose = () => {
    onClose();
    closeChooseCampaignTakeover();
  };

  return (
    <PageContainer>
      <Takeover
        isOverlay
        isMainApp
        noPadding
        withPortal
        onClose={handleOnClose}
        HeaderBarContent={<TakeoverMainHeader header={t('chooseCampaign.header')} />}
        Body={
          <ErrorBoundary teamName={Team.EXPERIMENT_TEAM} productName={Product.CHOOSE_CAMPAIGN}>
            <ChooseCampaignBody />
          </ErrorBoundary>
        }
      />
    </PageContainer>
  );
};
